import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MealType, returnMealType } from 'src/models/meal';
import { NEW_RECIPE } from 'src/models/recipe';
import { NavigationService } from '../services/navigation/navigation.service';
import { Location } from '@angular/common';
import { consoleSandbox } from '@sentry/utils';
import { MealService } from '../services/meal/meal.service';
import { RecipesService } from '../services/recipes/recipes.service';

@Component({
  selector: 'app-page-add-recipe-to-plan',
  templateUrl: './page-add-recipe-to-plan.component.html',
  styleUrls: ['./page-add-recipe-to-plan.component.scss']
})
export class PageAddRecipeToPlanComponent implements OnInit {

  type: MealType;
  dateString: string;
  allRecipes: NEW_RECIPE[] = [];
  filteredRecipes: NEW_RECIPE[] = [];

  constructor(
    private route: ActivatedRoute,
    private recipesService: RecipesService,
    private navigation: NavigationService,
    private location: Location,
    private mealService: MealService
  ) { }

  ngOnInit(): void {
    this.navigation.hide();
    this.type = returnMealType(this.route.snapshot.queryParamMap.get('type'));
    this.dateString = this.route.snapshot.queryParamMap.get('date');
    this.recipesService.query({}).then((recipes) => {
      this.allRecipes = [...recipes];
      this.filteredRecipes = [...recipes];
    });
  }

  debouncingTimeout;
  searching = false;
  firstLoad = true;


  searchChanged(termInput) {
    const lowercaseTerm = termInput.toLowerCase();
    const terms = lowercaseTerm.split(' ');

    if (this.debouncingTimeout || this.firstLoad) {
      this.firstLoad = false;
      this.searching = true;
      clearTimeout(this.debouncingTimeout);
      this.debouncingTimeout = setTimeout(() => {
        this.searching = false;
        const filteredRecipes = this.allRecipes.filter((recipe) => {
          let include = false;
          terms.forEach((term: string)=> {
            const name = recipe.name.toLowerCase();
            if (name.includes(term)) {
              include = true;
            }
            recipe.ingredients.map(i => i.original.toLowerCase()).forEach((ingredient)=> {
              if (ingredient.includes(term)){
                include = true;
              }
            });
          })
          return include;
        });
        this.filteredRecipes = filteredRecipes;
      }, 500);
    }


  }
  submit(e){
    console.log(e);
  }

  handleButtonClick() {
    this.filteredRecipes = this.allRecipes;
  }

  addToPlan(recipe: NEW_RECIPE){
    this.mealService.add(recipe, this.type, this.dateString, 1);
    this.goBack();
  }

  goBack(): void{
    this.navigation.show();
    this.location.back();
  }

}
